<!-- ProgressSpinner -->
<div class="flex align-items-center justify-content-center w-full pb-4 mb-4" *ngIf="loadingListNotifyConfig">
	<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>
<!-- List loaded -->
<form [formGroup]="notificationsConfigsForm" *ngIf="!loadingListNotifyConfig">
	<!-- USER && TECH INFO (Just for Technician Dialog) -->
	<div *ngIf="fromTechnicianDevicesManagement" class="grid mt-0">
		<div *ngIf="!iMTechOwner" [ngClass]="col6Responsive()">
			<p-tag class="flex align-items-center justify-content-center gap-2" icon="pi cm-user"
				value="{{ 'USER' | translate }} {{ 'OWNER' | translate }}: {{ device.FirstName }} {{ device.LastName }}"
				severity="info">
			</p-tag>
		</div>
		<div *ngIf="!iMTechOwner" [ngClass]="col6Responsive()">
			<p-tag class="flex align-items-center justify-content-center gap-2" icon="pi cm-technician"
				value="{{ 'TECHNICIAN' | translate }}: {{ currentUser.FirstName }} {{ currentUser.LastName }}"
				severity="warning">
			</p-tag>
		</div>
		<div *ngIf="iMTechOwner" class="col-12">
			<p-tag class="flex align-items-center justify-content-center gap-2" icon="pi cm-technician"
				value="{{ 'TECHNICIAN' | translate }} {{ 'OWNER' | translate }}: {{ currentUser.FirstName }} {{ currentUser.LastName }}"
				severity="warning">
			</p-tag>
		</div>
	</div>
	<div class="grid mt-0">
		<!-- LIST-->
		<div class="col-12" [ngClass]="customPaddingX()" *ngFor="let notify of listNotifyConfig">
			<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
				[ngClass]="simpleInputTextLayout('borderRow')">
				<div class="flex align-items-center justify-content-center pt-2 gap-2" [ngClass]="simpleInputTextLayout('label')">
					{{ notify.Name | translate }}
					<p-button *ngIf="notify.EventId === 26" pTooltip="{{'NOTIFY_OFFLINE_DEVICE_INFO' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
						size="large" [rounded]="false" [text]="true" severity="primary">
					</p-button>
				</div>
				<div class="flex align-items-end" [ngClass]="simpleInputTextLayout('borderInput')">
					<div [ngClass]="this.onExtendedMobile() ? 'grid mt-0' : 'flex flex-row gap-4'">
						<!-- USER / TECH OWNER -->
						<div class="flex align-items-center gap-2"
							[ngClass]="this.onExtendedMobile() ? (!iMTechOwner ? 'col-6 flex justify-content-center' : 'col-12 flex justify-content-center') : ''">
							<p-checkbox [formControlName]="notify.EventId+ '-' + notify.TerminalId + '-OwnerEnabled'"
								[binary]="true" (onChange)="saveNotify(notify)">
							</p-checkbox>
							<div *ngIf="!iMTechOwner">
								<i class="pi cm-user pl-1"></i>
								{{ 'USER' | translate }}
							</div>
							<div *ngIf="iMTechOwner">
								<i class="pi cm-technician pl-1"></i>
								{{ 'TECHNICIAN' | translate }} {{ 'OWNER' | translate }}
							</div>
						</div>
						<!-- TECH -->
						<div *ngIf="!iMTechOwner" class="flex align-items-center gap-2"
							[ngClass]="this.onExtendedMobile() ? 'col-6 flex justify-content-center' : ''">
							<p-checkbox [formControlName]="notify.EventId+ '-' + notify.TerminalId + '-TechnicianEnabled'"
								[binary]="true" (onChange)="saveNotify(notify)">
							</p-checkbox>
							<i class="pi cm-technician pl-1"></i>
							<div>{{ 'TECHNICIAN' | translate }}</div>
						</div>
						<!-- EMAIL -->
						<div class="flex align-items-center"
							[ngClass]="this.onExtendedMobile() ? 'grid w-full ml-0' : 'gap-2'">
							<div
								[ngClass]="this.onExtendedMobile() ? 'col-12 flex align-items-center justify-content-center flex-row gap-2' : 'flex flex-row gap-2'">
								<!-- <p-checkbox [formControlName]="notify.EventId+ '-' + notify.TerminalId + '-CustomEnabled'"
									[binary]="true" (onChange)="switchMailCheckbox($event, notify)">
								</p-checkbox> -->
								<i class="pi cm-mail pl-1"></i>
								<div>{{ 'CUSTOM_EMAIL' | translate }}</div>
							</div>
							<div
								[ngClass]="this.onExtendedMobile() ? 'col-12 flex align-items-center flex-column p-0' : 'flex gap-2'">
								<div [ngClass]="newShowErrors(notify, 'borderInput')">
									<input type="text" pInputText
										[formControlName]="notify.EventId+ '-' + notify.TerminalId + '-CustomRecipient'"
										[ngClass]="dynamicInputTextDesktopTabletWidth()"
										placeholder="{{ 'INSERT_EMAIL_ADDRESS' | translate }}" maxlength="30" />
								</div>
								<!-- !this.onExtendedMobile() EMAIL CUSTOM BUTTONS -->
								<p-button *ngIf="!this.onExtendedMobile()" pTooltip="{{ 'SAVE' | translate }}"
									tooltipPosition="bottom" icon="pi cm-check" styleClass="p-1 border-primary font-bold" [rounded]="false" [text]="true"
									severity="primary" (click)="submit(notify)" [disabled]="disableSaveButtonMail(notify)">
								</p-button>
								<p-button *ngIf="!this.onExtendedMobile()" pTooltip="{{ 'REMOVE' | translate }}"
									tooltipPosition="bottom" icon="pi cm-minus" styleClass="p-1 border-red-700 font-bold" [rounded]="false" [text]="true"
									severity="danger" (click)="remove(notify)" [disabled]="disableRemoveButtonMail(notify)">
								</p-button>
								<!-- this.onExtendedMobile() EMAIL CUSTOM BUTTONS -->
								<div class="flex flex-row align-items-center gap-1 pt-2 pb-3">
									<p-button *ngIf="this.onExtendedMobile()" icon="pi cm-check" [rounded]="false" [text]="true"
										severity="primary" label="{{ 'SAVE' | translate }} {{ 'EMAIL' | translate | lowercase }}" (click)="submit(notify)" styleClass="border-primary font-semibold"
										[disabled]="disableSaveButtonMail(notify)">
									</p-button>
									<p-button *ngIf="this.onExtendedMobile()" icon="pi cm-minus" [rounded]="false" [text]="true"
										severity="danger" label="{{ 'REMOVE' | translate }} {{ 'EMAIL' | translate | lowercase }}" (click)="remove(notify)" styleClass="border-red-700 font-semibold"
										[disabled]="disableRemoveButtonMail(notify)">
									</p-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(notify)" class="flex align-items-center text-50 pt-1"
				[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'EMAIL_ADDRESS_INVALID' | translate
				}}</small>
		</div>
	</div>
</form>